import setLang from '../lang';

const lang = {
    i: {
        locale: 'zh-TW',
        select: {
            placeholder: '請選擇',
            noMatch: '無匹配資料',
            loading: '加載中'
        },
        table: {
            noDataText: '暫無資料',
            noFilteredDataText: '暫無篩選結果',
            confirmFilter: '篩選',
            resetFilter: '重置',
            clearFilter: '全部'
        },
        datepicker: {
            selectDate: '選擇日期',
            selectTime: '選擇時間',
            startTime: '開始時間',
            endTime: '結束時間',
            clear: '清空',
            ok: '確定',
            datePanelLabel: '[yyyy年] [m月]',
            month: '月',
            month1: '1 月',
            month2: '2 月',
            month3: '3 月',
            month4: '4 月',
            month5: '5 月',
            month6: '6 月',
            month7: '7 月',
            month8: '8 月',
            month9: '9 月',
            month10: '10 月',
            month11: '11 月',
            month12: '12 月',
            year: '年',
            weekStartDay: '0',
            weeks: {
                sun: '日',
                mon: '一',
                tue: '二',
                wed: '三',
                thu: '四',
                fri: '五',
                sat: '六'
            },
            months: {
                m1: '1月',
                m2: '2月',
                m3: '3月',
                m4: '4月',
                m5: '5月',
                m6: '6月',
                m7: '7月',
                m8: '8月',
                m9: '9月',
                m10: '10月',
                m11: '11月',
                m12: '12月'
            }
        },
        transfer: {
            titles: {
                source: '來源列表',
                target: '目標列表'
            },
            filterPlaceholder: '請輸入搜尋內容',
            notFoundText: '列表爲空'
        },
        modal: {
            okText: '確定',
            cancelText: '取消'
        },
        poptip: {
            okText: '確定',
            cancelText: '取消'
        },
        page: {
            prev: '上一頁',
            next: '下一頁',
            total: '共',
            item: '條',
            items: '條',
            prev5: '向前 5 頁',
            next5: '向後 5 頁',
            page: '條/頁',
            goto: '跳至',
            p: '頁'
        },
        rate: {
            star: '星',
            stars: '星'
        },
        tree: {
            emptyText: '暫無資料'
        }
    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./~/iview/src/locale/lang/zh-TW.js